
import PromoMethods from 'src/pages/promotions/script/common.methods'
import {isEqual, isEmpty} from 'lodash'

export default {
  ...PromoMethods,
  setFontSelectOptions () {
    this.fontSelect.setOptions({
      obj: this.selectFontOptions,
      value: 'selectId',
      name: 'name',
      multiple: true
    })
  },
  setFontSelectValues (val) {
    this.setObjState(val, this.fontSelect)
    if (val) {
      if (val.value === '2a') {
        this.isSearch = true
        this.isSetAllFont(val.value)
        if(this.selectedList?.length) {
          this.setFontFamilyValues(this.selectedList)
        }
      } else {
        this.tickedFamilies = []
        this.isSearch = false
        this.isSetAllFont(val.value)
      }
      this.fontSelect.state = 'set'
      this.fontSelect.update(val, this.setFontSelectObject)
    } else {
      this.isSearch = false
      this.isSetAllFont(null)
    }
    this.isChecked = false
    this.isList = false
    this.searchedFamilies = []
  },
  updateFontSelectValues (val) {
    if (this.$route.name === 'new_promo') {
      this.setFontSelectValues(val)
    } else {
      if (this.fontSelectLoaded) {
        this.setFontSelectValues(val)
      }
      this.fontSelectLoaded = true
    }
  },
  setFontSelectObject () {
    this.setFontFamilyOptions()
    this.fontFamilies.values = null
  },
  // Search fonts in font families
  setFontFamilyOptions () {
    return new Promise(resolve => {
      this.fontFamilies.setOptions({
        obj: this.$store.getters['promotions/familiesList'],
        value: 'id',
        name: 'familyName',
        multiple: true
      })
    })
  },
  onFontFamiliesDeselected(val) {
    if(!isEmpty(val)) {
      this.setObjState(val, this.fontFamilies)
      if (this.isList) { this.isList = false }
      this.tickedFamilies = this.tickedFamilies.filter(ff => ff.id !== val.value)

      this.fontFamilies.state = 'set'
      this.fontFamilies.update(val, this.setFontFamilyObject)
      this.showCheckedFamilies()
      this.isTickFamilyRemoved = false
    }
  },
  setFontFamilyValues (val) {
    this.setObjState(val, this.fontFamilies)
    if (this.isList) { this.isList = false }
    if (val && !this.isTickFamilyRemoved) {
      const familiesList = [...this.$store.getters['promotions/familiesList']]
      // set family details in tickedFamilies array
      val.forEach((data) => {
        const selectedFamilyDetails = familiesList.find((details) => details.familyName === data.label)
        if (!this.valueExistInTickedFamilies(data.value)) { this.tickedFamilies.push(selectedFamilyDetails) }
      })
      // Check to update ticked Families if any font is removed from selected list
      if (val.length !== this.tickedFamilies.length && this.tickedFamilies.length > val.length) {
        const filteredList = this.tickedFamilies.filter((data) => {
          const getIndex = val.findIndex((e) => e.value === data.id)

          return getIndex !== -1
        })
        this.tickedFamilies = filteredList
      }
      this.fontFamilies.update(val, this.setFontFamilyObject)
      this.showCheckedFamilies()
    } else {
      this.isTickFamilyRemoved = false
    }
  },
  valueExistInTickedFamilies (val) {
    const getIndex = this.tickedFamilies.findIndex((data) => {
      return data.id === val
    })

    return getIndex > -1
  },
  setFontFamilyObject () {
    const families = [...this.$store.getters['promotions/familiesList']]
    const searchedFamilies = families.filter((val) => val.familyName.includes(this.fontFamilies.values.label))
    this.searchedFamilies = searchedFamilies
  },
  viewAllFamilies () {
    this.fontFamilies.values = null
    this.setObjState(null, this.fontFamilies)
    const searchedFamilies = [...this.$store.getters['promotions/familiesList']]
    this.$nextTick()
      .then(() => {
        this.isList = true
        this.searchedFamilies = searchedFamilies
      })
  },
  getMyfontsFamilyIds (arr) { return arr.map((val) => val.id) },
  resetInternalStateForPacks () {
    this.allPacks = []
    this.allStyles = []
    this.stylePacks = []
    this.familyCustomPacks = []
    this.onlySingleStylePack = []
  },
  removeStyleFamilyCustomPacks (taggedFamilies, all = false) {
    if (all) {
      return this.resetInternalStateForPacks()
    }
    const expectedSingleStylePacks = []
    const expectedCustomFamilyPacks = []
    const expectedSingleStyleOnlyPacks = []
    const allExpectedAllStyles = taggedFamilies.map((data) => `allStyles-${data.id}`)
    const allExpectedAllPacks = taggedFamilies.map((data) => `allPacks-${data.id}`)

    taggedFamilies.forEach(({ skus }) => {
      if (isEqual(skus.length, 1)) {
        expectedSingleStyleOnlyPacks.push(skus[0].skuId)
      } else {
        skus.forEach(({ packageType, skuId }) => {
          if (isEqual(packageType, 'singleStyle')) {
            expectedSingleStylePacks.push(skuId)
          } else {
            expectedCustomFamilyPacks.push(skuId)
          }
        })
      }
    })
    // Update the internal state
    this.allStyles = allExpectedAllStyles.filter((id) => { return this.allStyles.includes(id) })
    this.allPacks = allExpectedAllPacks.filter((id) => { return this.allPacks.includes(id) })
    this.stylePacks = expectedSingleStylePacks.filter((id) => { return this.stylePacks.includes(id) })
    this.familyCustomPacks = expectedCustomFamilyPacks.filter((id) => { return this.familyCustomPacks.includes(id) })
    this.onlySingleStylePack = expectedSingleStyleOnlyPacks.filter((id) => { return this.onlySingleStylePack.includes(id) })
  },
  showCheckedFamilies (event, isViewAllEvent = false) {
    event?.preventDefault()
   if (isViewAllEvent) {
      this.isViewAllAddBtnDisable = true
      this.tickedFamilies = this.searchedFamilies.filter((data) => { return this.viewAllTickedFamilesIdArr.includes(data.id) })
    }
    // When selected families array is Empty
    if (isEqual(this.tickedFamilies.length, 0)) {
      this.isTickFamilyRemoved = true
      this.isChecked = false
      this.isViewAllAddBtnDisable = false
      this.selectedList = []
      this.viewAllTickedFamilesIdArr = []
      this.removeStyleFamilyCustomPacks([], true)
      this.$store.commit('promotions/clearTaggedFamilies')
      this.$store.commit('promotions/clearTaggedErrorFamilies')
    }
    // When selected families array is not Empty
    if (this.tickedFamilies.length > 0) {
      this.isChecked = false
      this.fontFamilies.values = null
      this.$events.$emit('reset:family_ids')
      this.selectedList = this.tickedFamilies.map((data) => ({ value: data.id, label: data.familyName }))
      this.$store.dispatch('promotions/getTaggedFamilies', {
        familyIds: this.getMyfontsFamilyIds(this.tickedFamilies)
      }).then((data) => {
        this.isChecked = true
        this.isViewAllAddBtnDisable = false
        if (data.length > 0) {
          this.viewAllTickedFamilesIdArr = data.map((item) => item.id)
          this.removeStyleFamilyCustomPacks(data, false)
        }
      })
    }
    if (this.tickedFamilies.length === 0) {
      this.isChecked = false
      this.isViewAllAddBtnDisable = false
      this.viewAllTickedFamilesIdArr = []
      this.$store.commit('promotions/clearTaggedFamilies')
      this.$store.commit('promotions/clearTaggedErrorFamilies')
    }
  },
  removeTickFamily (id) {
    this.tickedFamilies = this.tickedFamilies.filter(val => val.id !== id)
    let leftOverSelectedFamiliesList = []
    let leftOverSelectedFamiliesForViewAllList = []
    this.tickedFamilies.forEach((data) => {
      leftOverSelectedFamiliesList = [...leftOverSelectedFamiliesList, { value: data.id, label: data.familyName }]
      leftOverSelectedFamiliesForViewAllList = [...leftOverSelectedFamiliesForViewAllList, data.id]
    })
    this.isTickFamilyRemoved = true
    if (isEqual(this.tickedFamilies.length, 0)) { this.isChecked = false }

    // updating the internal state for packs
    this.removeStyleFamilyCustomPacks(this.taggedFamilies, false)

    // Updating the Internal State
    this.selectedList = leftOverSelectedFamiliesList
    this.viewAllTickedFamilesIdArr = leftOverSelectedFamiliesForViewAllList
  },
  // Is Old tagged family in Edit Promotion
  isOldTaggedFamilyInEditPromotion (familyId) {
    const savedFamiliesIdsArr = this.editPromotionTickedFamilies.map((data) => String(data.familyId))
    return !(savedFamiliesIdsArr.includes(familyId))
  }
}
